<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Sổ sách giáo viên" :link="[{ text: 'Cấp học', href: '../teachingDoc' }]" />
      </div>
    </div>
    <div v-if="loading" class="loading-container">
      <v-progress-circular indeterminate size="40"></v-progress-circular>
    </div>
    <div v-else class="d-flex justify-center align-center flex-column">
      <div class="card-container" v-for="academicLevel in academicLevels" :key="academicLevel.type">
        <v-card
          @click="toggleCard(academicLevel.type)"
          :style="{ transform: cardClicked[academicLevel.type] ? 'translateX(-100px)' : 'none' }"
          class="mb-4 card"
          outlined
        >
          <v-row class="d-flex justify-center align-center">
            <v-col cols="9">
              <v-col cols="12" class="d-flex flex-row align-center">
                <div class="ml-4 mr-8">
                  <h2>{{ academicLevel.title }}</h2>
                </div>
              </v-col>
              <v-col class="mx-4" cols="12">
                <p>{{ academicLevel.type | gradePerLevel }}</p></v-col
              >
            </v-col>
          </v-row>
        </v-card>
        <transition @enter="showButtons = true" @leave="showButtons = false" name="slide">
          <div v-show="cardClicked[academicLevel.type]" class="card-buttons">
            <router-link :to="`/teachingDoc/${academicLevel.type}/teachingCat/`">
              <v-btn class="mr-2" style="margin-bottom: 20px;">Giảng dạy</v-btn>
            </router-link>
            <router-link :to="`/teachingDoc/${academicLevel.type}/teacherOwnClassCat/`">
              <v-btn>Chủ nhiệm</v-btn>
            </router-link>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { AcademicLevel } from '@/plugins/api'

export default {
  components: {
    Breadcrumbs
  },

  data() {
    return {
      loading: true,
      showButtons: false,
      cardClicked: {
        secondary: false,
        high: false
      },
      academicLevels: []
    }
  },

  methods: {
    toggleCard(cardType) {
      this.cardClicked[cardType] = !this.cardClicked[cardType]
    }
  },

  async mounted() {
    try {
      const acaLevels = await AcademicLevel.fetch({ status: 'active' })
      acaLevels.sort((a, b) => {
        const numberA = Number(a.title.slice(-1))
        const numberB = Number(b.title.slice(-1))
        return numberA - numberB
      })
      this.academicLevels = acaLevels || []
    } catch (error) {
      console.error('Error fetching academic levels:', error)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.card-container {
  display: flex;
  align-items: center;
  position: relative;
  width: 400px;
}

.card {
  transition: transform 0.3s ease;
  width: 500px;
}

.card-buttons {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  position: absolute;
  right: -30px;

  transition: opacity 0.3s ease;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
